module.exports = __webpack_public_path__ + "img/eg-hk-02.5d98fba5.png";